import { isNil } from 'lodash';
import { convertEmptyToNull, highlight } from 'utils/stringUtils';
import { t } from 'i18next';

export interface IProjectPickerTitleProps {
  title: string;
  projectInfo?: { number?: string | null } | null;
  searchValue: string;
}

function ProjectPickerTitle({ title, projectInfo, searchValue }: IProjectPickerTitleProps) {
  return (
    <>
      {highlight(title, searchValue)}
      {projectInfo?.number &&
        !isNil(convertEmptyToNull(searchValue)) &&
        projectInfo.number.toLowerCase().includes(searchValue.toLowerCase()) && (
          <>
            <br />
            <div className="f-sm fc-2 ellipsis">
              <b>{t('Proj #: ')}</b>
              {highlight(projectInfo.number, searchValue)}
            </div>
          </>
        )}
    </>
  );
}

export default ProjectPickerTitle;
